import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchAppConfig } from './firebase';
import {
  STATUS_FETCHING,
  STATUS_ERROR,
  STATUS_READY,
  STATUS_IDLE
} from './constants';

export const fetchEnv = createAsyncThunk('fetchEnv', async () => await fetchAppConfig());

const appSlice = createSlice({
  name: 'app',
  initialState: {
    status: STATUS_IDLE,
    env: null
  },
  reducers: {},
  extraReducers (builder) {
    builder
      .addCase(fetchEnv.pending, (state, action) => {
        state.status = STATUS_FETCHING
      })
      .addCase(fetchEnv.fulfilled, (state, action) => {
        state.status = STATUS_READY
        state.env = action.payload
      })
      .addCase(fetchEnv.rejected, (state, action) => {
        state.status = STATUS_ERROR
        state.error = action.error.message
      })
  }
})

export default appSlice.reducer
